module.exports = {
    property_top_up: '資產充值',
    main_net: '主網',
    wallet_address: '錢包地址（此地址只可接收USDT）',
    important_tip: '重要提示',
    least_top_up_money: '最少充值金額爲',
    top_up_tip1: '請仔細確認地址，充錯無法找回',
    top_up_tip2: '大約3~5分鐘到賬',
    confirm: '確定',
    get_tip: '獲取資產充值信息失敗 !',
    copy_success: '複製成功 !',
    arrival_accounts: '到賬賬戶',
    funding_accounts: '資金賬戶',
    recharge_amount: '充值金額',
    payment_method: '充值方式',
    go_to_recharge: '立即充值',
    confirm_recharge: '確認儲值',
    to_copy_address: '點選複製下方儲值地址',
    please_be_sure_to: '請務必在',
    please_regenerate_recharge_order: '之前完成付款超時請重新生成充值訂單',
    please_enter_recharge_amount: '請輸入充值金額',
    transaction_account: '網站新增“交易帳戶”作為機器人運轉的專屬扣費帳戶，您需將資金劃轉至“交易帳戶”以保證機器人的正常運行。',
    i_see: '我知道了',
    payment_public: '1. 當前USDT支付公鏈協議為{method}',
    please_recharge_amount: '充值金額請務必按照上方顯示金額充值',
    system_cannot: '否則系統無法確認充值成功，如充值金額與上方顯示金額不一致，系統無法找回！'

}
